/*
 * rebuy-bridge.js — Cart icon + ATC event bridge to Rebuy SmartCart
 * Added: 2026-04-28
 *
 * WHY: The native quick-cart drawer is hidden in the theme editor (so .quick-cart
 * is not in the DOM), but the compiled theme.js cart-icon click handler and
 * post-add-to-cart open event are gated on .quick-cart existing. With it gone,
 * cart icon clicks navigate to /cart and add-to-cart drops its open event,
 * causing the /cart -> /?viewcart=true -> /cart redirect ping-pong.
 *
 * This bridge listens for the cart icon click and the cart open events and
 * forwards them to Rebuy.SmartCart.show().
 *
 * ── HOW TO REVERT ────────────────────────────────────────────────────────────
 * 1. Delete this file: assets/rebuy-bridge.js
 * 2. In layout/theme.liquid, remove the line:
 *      <script src="{{ 'rebuy-bridge.js' | asset_url }}" defer></script>
 *    (it's right after the Rebuy CDN <script async> tag near the bottom of <body>)
 * 3. shopify theme push
 * No other files touch this. Rollback is two file changes, fully self-contained.
 * ─────────────────────────────────────────────────────────────────────────────
 */
(function () {
  // Click listeners are attached IMMEDIATELY on script load — not after Rebuy is
  // ready. If the user clicks the cart before Rebuy finishes loading, we
  // preventDefault and queue the open call so it fires the moment Rebuy is up.
  // Without this, fast-clicking before Rebuy loads falls back to the <a href="/cart">
  // navigation, which then triggers the /cart -> /?viewcart=true ping-pong.

  var FALLBACK_TIMEOUT_MS = 5000; // hard cap: if Rebuy never loads, send to /cart

  function rebuyReady() {
    return window.Rebuy
      && window.Rebuy.SmartCart
      && typeof window.Rebuy.SmartCart.show === 'function';
  }

  function showRebuyNow() {
    try {
      window.Rebuy.SmartCart.show();
    } catch (e) {
      window.location.href = '/cart';
    }
  }

  // Open Rebuy if ready; otherwise poll until it is, then open. Each call gets
  // its own timeout window — multiple queued calls collapse into one open since
  // SmartCart.show() is idempotent.
  function openRebuy() {
    if (rebuyReady()) { showRebuyNow(); return; }

    var startedAt = Date.now();
    (function poll() {
      if (rebuyReady()) { showRebuyNow(); return; }
      if (Date.now() - startedAt >= FALLBACK_TIMEOUT_MS) {
        // Rebuy never came online — last resort, send the user to /cart so they
        // aren't stranded with a broken click.
        window.location.href = '/cart';
        return;
      }
      setTimeout(poll, 100);
    })();
  }

  // 1. Delegated click on the cart icon. Bound immediately so early clicks are
  //    captured before Rebuy is ready.
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var icon = target.closest('a[data-js-cart-icon]');
    if (!icon) return;
    // Allow modifier-clicks (cmd/ctrl/middle/shift) to do their default —
    // open in new tab, etc.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    openRebuy();
  }, false);

  // 2. Bridge the theme's pubsub events that fire after add-to-cart.
  //    The theme dispatches CustomEvents on document when its useCustomEvents
  //    flag is on; we listen for both spellings.
  ['quick-cart:open', 'cart:open', 'cart:item-added'].forEach(function (evt) {
    document.addEventListener(evt, function () { openRebuy(); }, false);
  });
})();
